import { useContext } from "react";
import State from "../../../../../../context";
import { Flex } from "antd";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import ModalClientPersonalInfo from "../PagePeople/components/SectionDetailsClient/ModalClientPersonalInfo";
import SectionDetailsClient from "../PagePeople/components/SectionDetailsClient";
import SectionHome from "./component/SectionHome";
import SecurityGate from "../../../../../../provider/SecurityGate";

import StyledContainer from "./style";

import {
  openProposal,
  updateManagedUser,
} from "../../../../../../utils/request/manager";
import {
  getSavedProposalsAll,
  isPermissionReadonly,
} from "../../../super_admin/helper";
import { getAllManagedClientsOfAdvisors } from "../../../../../../utils/helper/specialized";

import { faArrowLeft } from "@fortawesome/free-solid-svg-icons";

const PageProposals = () => {
  const [state] = useContext(State);

  const onProposalClick = clientEmail => {
    state.setKeyValue("activeEmail", clientEmail);
    state.setKeyValue("activeSection", "proposal");
  };

  const onClickEditInfo = editClientInfoViewType => {
    state.setKeyValue("editClientInfoViewType", editClientInfoViewType);
    state.setKeyValue("openModalClientPersonalInfo", true);
  };

  const onClickProposalOpen = ({
    advisorEmail,
    clientEmail = state.activeEmail,
  }) => {
    openProposal({
      advisorEmail,
      clientEmail,
      managerEmail: state._id,
    }).catch(state.showError);
  };

  const submitClientPersonalInfo = values => {
    state.setKeyValue("loading", true);

    updateManagedUser({
      managerEmail: state._id,
      requestPayload: values,
    })
      .then(() =>
        state
          .setUserData()
          .then(() => {
            values.email && state.setKeyValue("activeEmail", values.email);
            state.setKeyValue("openModalClientPersonalInfo", false);
            state.showSuccess("Personal data updated");
          })
          .catch(state.showError)
          .finally(() => state.setKeyValue("loading", false))
      )
      .catch(error => {
        state.showError(error);
        state.setKeyValue("loading", false);
      });
  };

  return (
    <SecurityGate state={state}>
      <StyledContainer>
        {state.activeSection === "proposal" && (
          <SectionDetailsClient
            clientData={getAllManagedClientsOfAdvisors(
              state.managedUserManagers
            )?.find(it => it.email === state.activeEmail)}
            disableEdit={isPermissionReadonly(
              state.permissions?.manageProposals
            )}
            onClickProposalOpen={onClickProposalOpen}
            itemsBreadcrumb={[
              {
                onClick: () => state.setKeyValue("activeSection", "home"),
                title: (
                  <Flex align="center" gap={8} style={{ cursor: "pointer" }}>
                    <FontAwesomeIcon
                      icon={faArrowLeft}
                      style={{ fontSize: 14 }}
                    />
                    <b>All Users</b>
                  </Flex>
                ),
              },
              {
                title: <span>User Profile</span>,
              },
            ]}
            managerEmail={state._id}
            onClickEditInfo={onClickEditInfo}
            organization={state.organization?.name}
            productsList={state.productsList}
          />
        )}

        {state.activeSection !== "proposal" && (
          <SectionHome
            dataSource={getSavedProposalsAll({
              managedUsers: getAllManagedClientsOfAdvisors(
                state.managedUserManagers
              )?.map((it, index) => ({
                ...it,
                key: index,
              })),
              productsList: state.productsList,
            })}
            loading={state.loading}
            onProposalClick={onProposalClick}
          />
        )}

        <ModalClientPersonalInfo
          clientData={getAllManagedClientsOfAdvisors(
            state.managedUserManagers
          )?.find(it => it.email === state.activeEmail)}
          loading={state.loading}
          onCancel={() =>
            state.setKeyValue("openModalClientPersonalInfo", false)
          }
          onFinish={submitClientPersonalInfo}
          open={state.openModalClientPersonalInfo}
          viewType={state.editClientInfoViewType}
        />
      </StyledContainer>
    </SecurityGate>
  );
};

export default PageProposals;
